
import { LoginController } from "kwest-web-sdk/browser";
import {setEnv} from "kwest-web-sdk";


var username = localStorage.getItem('kwest-username') || '';
var users = [];
var categoryOptions = [];
var ccUsers = [];
var idempotency = null;
var sendingTicket = false;
var attachedFiles = [];
var aiUsed = false;

setEnv("AUTH_SERVICE_URL","https://api.kwestgroup.com/auth")


var loginController = new LoginController({
  ...LoginController.browserLoginEnvironment,
  saveLogin: (r) => {
      if (r && r.user && r.user.username) {
        username = r.user.username;
        localStorage.setItem('kwest-username', r.user.username);
        localStorage.setItem('kwest-api-token', r.token);
      }
  },
  loadLogin: () => {
   const username = localStorage.getItem('kwest-username')
   const token = localStorage.getItem('kwest-api-token')
   if (username && token) {
    return {user: {username}, token}
   } else {
    return null
   }
  }
})


hideDisplayForms();
updateId();
loginFormInput(); // enable submit if the browser autofilled credentials before any keystroke
loginController.loadOrContinueLogin()

function hideDisplayForms() {
  var token = localStorage.getItem('kwest-api-token');
  if (token) {
    document.getElementById('loginFormContainer').style.display = 'none';
    document.getElementById('ticketFormContainer').style.display = 'block';
    getData();
    document.getElementById('subject').focus();
  } else {
    document.getElementById('loginFormContainer').style.display = 'block';
    document.getElementById('ticketFormContainer').style.display = 'none';
  }
}

function updateId() {
  idempotency = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString();
}

function loginFormInput() {
  //disable submit button if form not filled out
  var f = document.getElementById('loginForm');
  var b = document.getElementById('loginSubmitButton');
  if (f['username'].value && f['password'].value) {
    b.disabled = false;
  } else {
    b.disabled = true;
  }
}

function onLogin(f) {
  var eDi = document.getElementById('loginMessageBad');
  eDi.textContent = 'Sending credentials...';
  eDi.parentElement.style.display = 'block';
  (async () => {
    try {
      // submitLogin never throws on auth failure (SDK uses validateStatus: () => true).
      // Success is signalled by saveLogin writing the token; an error result carries a message.
      var result = await loginController.submitLogin({
        username: f['username'].value,
        password: f['password'].value,
      })

      if (localStorage.getItem('kwest-api-token')) {
        eDi.parentElement.style.display = 'none';
        eDi.textContent = '';
        hideDisplayForms();
        return;
      }

      eDi.textContent = (result && result.message)
        || 'Login did not complete. New employees must finish MFA enrollment before signing in.';
    } catch (e) {
      console.error(e.message)
      eDi.textContent = 'Unable to reach the login service. Please try again.';
    }
  })()
}

function onLogout() {
  localStorage.removeItem('kwest-username');
  localStorage.removeItem('kwest-api-token');
  // Clear attachments on logout
  attachedFiles = [];
  location.reload();
}

function getData() {
  (async () => {
    try {
      var token = localStorage.getItem('kwest-api-token');
      const response = await fetch('/user', {
        headers: {
          'content-type': 'application/json',
          'authorization': 'Bearer ' + token
        },
        method: 'GET'
      })
      const text = await response.text();
      if (response.status !== 200) {
        if (text && text.length > 0) {
          console.error(text)
        } else {
          console.error('There was an error')
        }
        return
      }
      users = JSON.parse(text);
      //set from in form to user
      var fromName = '';
      users.forEach(function(u){
        if (u.email.toLowerCase().includes(username.toLowerCase()+'@')) {
          fromName = u.name;
        }
      });
      // Fall back to username if employee service returned no match
      if (!fromName && username) {
        fromName = username;
      }
      document.getElementById('submittedBy').value = fromName;
    } catch (e) {
      console.error(e.message)
    }
  })();
  (async () => {
    try {
      var token = localStorage.getItem('kwest-api-token');
      const response = await fetch('/category', {
        headers: {
          'content-type': 'application/json',
          'authorization': 'Bearer ' + token
        },
        method: 'GET'
      })
      const text = await response.text();
      if (response.status !== 200) {
        if (text && text.length > 0) {
          console.error(text)
        } else {
          console.error('There was an error')
        }
        return
      }
      categoryOptions = JSON.parse(text);
      updateCategoriesInForm();
    } catch (e) {
      console.error(e.message)
    }
  })();
}

function updateCategoriesInForm() {
  var s = document.getElementById('category');
  if (!s || !categoryOptions.length) {
    return;
  }
  s.innerHTML = '';
  var o = document.createElement('option');
  o.textContent = 'Choose Category';
  o.value = '';
  s.appendChild(o);
  categoryOptions.forEach(function(c){
    o = document.createElement('option');
    o.textContent = c.name;
    o.value = c.value;
    s.appendChild(o);
  });
  updateHcssSupportNotice();
}

function updateHcssSupportNotice() {
  var notice = document.getElementById('hcssSupportNotice');
  var category = document.getElementById('category');
  if (!notice || !category) {
    return;
  }

  var selectedOption = category.options[category.selectedIndex];
  var selectedText = selectedOption ? selectedOption.textContent.trim().toLowerCase() : '';
  var selectedValue = category.value ? category.value.trim().toLowerCase() : '';
  var isHcss = selectedText === 'hcss' || selectedValue === 'hcss';

  notice.style.display = isHcss ? 'block' : 'none';
}

function formInput() {
  //disable submit button if form not filled out
  updateHcssSupportNotice();
  var b = document.getElementById('ticketSubmitButton');
  var subject = document.getElementById('subject').value;
  var comment = document.getElementById('comment').value.trim();
  var category = document.getElementById('category').value;
  var priority = document.getElementById('priority').value;
  var submittedBy = document.getElementById('submittedBy').value;
  if (subject && comment && category && priority && submittedBy) {
    b.disabled = false;
  } else {
    b.disabled = true;
  }
}

function refreshCC() {
  var eCC = document.getElementById('cc');
  eCC.innerHTML = '';
  ////////
  ccUsers.forEach(function(u){
    //<span class="ccName">Penny Jane Marshall<span class="closeGadget">x</span></span>
    var eCCName = document.createElement('span');
    eCCName.classList.add('ccName');
    eCCName.innerHTML = u.name;
    var ed = document.createElement('span');
    ed.classList.add('closeGadget');
    ed.innerHTML = 'x';
    eCCName.appendChild(ed);
    ed.onclick = function(e){
      e.stopPropagation();
      removeCC(u);
    }
    eCC.appendChild(eCCName);
  });
}

function ccClicked() {
  //add input to cc
  refreshCC();
  var eCC = document.getElementById('cc');
  var eInput = document.createElement('input');
  eCC.appendChild(eInput);
  eInput.focus();
  eInput.onblur = function(){
    refreshCC();
    hideSR();
  };
  eInput.onkeyup = ccType;
  updateSearchResultsContainer('');
}

function ccType(e) {
  updateSearchResultsContainer(e.target.value);
}

function updateSearchResultsContainer(s) {
  if (s) {
    s = s.trim();
    s = s.toLowerCase();
  }
  var eSearchResultsContainer = document.getElementById('srco');
  eSearchResultsContainer.innerHTML = '';
  var eSR = document.createElement('div');
  eSR.classList.add('searchResults');
  var us = users.filter(function(u){
    if (!s) {
      return true;
    }
    return u.email.toLowerCase().indexOf(s) !== -1 || u.name.toLowerCase().indexOf(s) !== -1
  });
  us.forEach(function(u){
    var e = document.createElement('span');
    e.classList.add('sr');
    e.innerHTML = u.name;
    e.onmousedown = function(){
      addCC(u);
      refreshCC();
      hideSR();
    }
    eSR.appendChild(e);
  });
  eSearchResultsContainer.appendChild(eSR);
}

function addCC(u) {
  if (!ccUsers.includes(u)) {
    ccUsers.push(u);
  }
  refreshCC();
}

function removeCC(u) {
  ccUsers = ccUsers.filter(function(us){
    return us !== u;
  });
  refreshCC();
}

function hideSR() {
  var eSearchResultsContainer = document.getElementById('srco');
  eSearchResultsContainer.innerHTML = '';
}

function onTicket(f) {
  var r = {};
  users.forEach(function(u){
    if (u.email.toLowerCase().includes(username.toLowerCase()+'@')) {
      r.name = u.name;
      r.email = u.email;
    }
  });
  if (!r.email) {
    alert('Unable to get user data...');
    return;
  }
  var comment = f['comment'].value.trim();
  if (!comment) {
    var eDiBad = document.getElementById('ticketMessageBad');
    eDiBad.textContent = 'Please enter a description before submitting.';
    eDiBad.parentElement.style.display = 'block';
    return;
  }

  var ticket = {
    idempotency: idempotency,
    requester: r,
    subject: f['subject'].value,
    comment: {body: comment},
    priority: f['priority'].value,
    custom_fields: [{"id": 8525751572631, value: f['category'].value}]
  }
  if (ccUsers.length) {
    ticket.email_ccs = [];
    ccUsers.forEach(function(u){
      ticket.email_ccs.push({
        user_email: u.email,
        user_name: u.name
      });
    });
  }

  var ticketJSON = JSON.stringify(ticket);

  var eDi = document.getElementById('ticketMessageBad');

  if (sendingTicket) {
    return;
  }
  sendingTicket = true;

  (async () => {
    try {
      var token = localStorage.getItem('kwest-api-token');

      // Create FormData to send both ticket data and files
      var formData = new FormData();
      formData.append('ticketData', ticketJSON);

      // Add all attached files
      attachedFiles.forEach(function(fileObj) {
        formData.append('attachments', fileObj.file);
      });

      console.log('Submitting ticket with', attachedFiles.length, 'attachments');

      // Show appropriate progress message
      if (attachedFiles.length > 0) {
        eDi.textContent = 'Uploading ' + attachedFiles.length + ' attachment(s) and submitting ticket...';
        eDi.parentElement.style.display = 'block';
      } else {
        eDi.textContent = 'Submitting ticket...';
        eDi.parentElement.style.display = 'block';
      }

      const response = await fetch('/ticket', {
        headers: {
          'authorization': 'Bearer ' + token
          // Note: Don't set content-type header, browser will set it with boundary for multipart/form-data
        },
        method: 'POST',
        body: formData
      })
      const text = await response.text();
      if (response.status !== 200) {
        eDi.parentElement.style.display = 'block';
        if (text && text.length > 0) {
          try {
            var r = JSON.parse(text);
            eDi.textContent = r.message || 'Unspecified server error...';
            console.error('Server error:', r);
          } catch (parseErr) {
            eDi.textContent = 'Server error: ' + text;
            console.error('Server returned non-JSON error:', text);
          }
        } else {
          eDi.textContent = 'Unknown server error occurred';
          console.error('Empty error response from server')
        }
        sendingTicket = false;
        return;
      }

      // Hide error message on success
      eDi.parentElement.style.display = 'none';
      eDi.textContent = '';

      document.getElementById('ticketFormContainer').style.display = 'none';
      document.getElementById('ticketSuccessContainer').style.display = 'block';

      // Clear attachments after successful submission
      attachedFiles = [];
      renderAttachmentThumbnails();
      updateAttachmentSizeWarning();

      updateId();
      sendingTicket = false; // CRITICAL FIX: Reset flag after success
    } catch (e) {
      console.error('Exception during ticket submission:', e.message)
      eDi.parentElement.style.display = 'block';
      eDi.textContent = e.message || 'Unspecified error sending ticket...';
      sendingTicket = false;
    }
  })()
}

function triggerFileInput() {
  document.getElementById('fileInput').click();
}

function handleFileSelection(event) {
  const files = Array.from(event.target.files);

  // Define allowed file types
  const allowedTypes = [
    'image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp',
    'application/pdf',
    'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain', 'text/csv',
    'application/zip', 'application/x-zip-compressed',
    'video/mp4', 'video/mpeg', 'video/quicktime'
  ];

  const maxFileSize = 50 * 1024 * 1024; // 50MB per file
  const maxTotalSize = 200 * 1024 * 1024; // 200MB total

  // Calculate current total size
  let currentTotalSize = attachedFiles.reduce((sum, f) => sum + f.size, 0);

  files.forEach(file => {
    // Validate file type
    if (file.type && !allowedTypes.includes(file.type)) {
      alert('File type not allowed: ' + file.name + '\nAllowed types: Images, PDFs, Office documents, Text files, Videos, and ZIP files');
      return;
    }

    // Validate individual file size
    if (file.size > maxFileSize) {
      alert('File too large: ' + file.name + '\nMaximum file size is 50MB');
      return;
    }

    // Validate total size
    if (currentTotalSize + file.size > maxTotalSize) {
      alert('Total upload size would exceed 200MB limit. Please remove some files first.');
      return;
    }

    currentTotalSize += file.size;
    addAttachment(file);
  });

  // Reset file input so the same file can be added again if needed
  event.target.value = '';
}

function addAttachment(file) {
  // Create a file object with metadata
  const fileObj = {
    file: file,
    id: Date.now() + Math.random(), // Unique ID for this attachment
    name: file.name,
    size: file.size,
    type: file.type
  };

  attachedFiles.push(fileObj);

  renderAttachmentThumbnails();
  updateAttachmentSizeWarning();
}

function removeAttachment(fileId) {
  attachedFiles = attachedFiles.filter(f => f.id !== fileId);
  console.log('Removed attachment. Remaining attachments:', attachedFiles.length);
  renderAttachmentThumbnails();
  updateAttachmentSizeWarning();
}

function updateAttachmentSizeWarning() {
  const warningElement = document.getElementById('attachmentSizeWarning');
  const sizeBarElement = document.getElementById('attachmentSizeBar');
  const sizeBarFill = document.getElementById('sizeBarFill');
  const sizeBarText = document.getElementById('sizeBarText');

  const maxTotalSize = 200 * 1024 * 1024; // 200MB
  const currentTotalSize = attachedFiles.reduce((sum, f) => sum + f.size, 0);
  const percentUsed = (currentTotalSize / maxTotalSize) * 100;
  const usedMB = (currentTotalSize / (1024 * 1024)).toFixed(1);

  // Show/hide and update the progress bar
  if (attachedFiles.length > 0) {
    if (sizeBarElement) sizeBarElement.style.display = 'block';
    if (sizeBarFill) {
      sizeBarFill.style.width = percentUsed + '%';

      // Update color based on usage
      sizeBarFill.classList.remove('warning', 'danger');
      if (percentUsed >= 90) {
        sizeBarFill.classList.add('danger');
      } else if (percentUsed >= 75) {
        sizeBarFill.classList.add('warning');
      }
    }
    if (sizeBarText) {
      sizeBarText.textContent = usedMB + ' MB / 200 MB';
    }
  } else {
    if (sizeBarElement) sizeBarElement.style.display = 'none';
  }

  // Show/hide text warning
  if (warningElement) {
    if (percentUsed >= 90) {
      const remainingMB = ((maxTotalSize - currentTotalSize) / (1024 * 1024)).toFixed(1);
      warningElement.textContent = '⚠ ' + remainingMB + ' MB remaining of 200 MB limit';
      warningElement.style.display = 'inline-block';
    } else if (percentUsed >= 75) {
      warningElement.textContent = '⚠ Approaching upload limit';
      warningElement.style.display = 'inline-block';
    } else {
      warningElement.style.display = 'none';
    }
  }
}

function renderAttachmentThumbnails() {
  const container = document.getElementById('attachmentThumbnails');
  container.innerHTML = '';

  if (attachedFiles.length === 0) {
    return;
  }

  attachedFiles.forEach(fileObj => {
    const thumbnail = document.createElement('div');
    thumbnail.classList.add('attachment-thumbnail');

    // Create preview element
    const preview = document.createElement('div');
    preview.classList.add('attachment-preview');

    // Check if it's an image file for preview
    if (fileObj.type.startsWith('image/')) {
      const img = document.createElement('img');
      img.classList.add('attachment-image');
      const reader = new FileReader();
      reader.onload = function(e) {
        img.src = e.target.result;
      };
      reader.readAsDataURL(fileObj.file);
      preview.appendChild(img);
    } else {
      // Show file icon with extension
      const fileIcon = document.createElement('div');
      fileIcon.classList.add('attachment-file-icon');
      const extension = fileObj.name.split('.').pop().toUpperCase();
      fileIcon.textContent = extension.substring(0, 4);
      preview.appendChild(fileIcon);
    }

    // Create file info
    const info = document.createElement('div');
    info.classList.add('attachment-info');

    const fileName = document.createElement('div');
    fileName.classList.add('attachment-name');
    fileName.textContent = fileObj.name.length > 20 ? fileObj.name.substring(0, 17) + '...' : fileObj.name;
    fileName.title = fileObj.name;

    const fileSize = document.createElement('div');
    fileSize.classList.add('attachment-size');
    fileSize.textContent = formatFileSize(fileObj.size);

    info.appendChild(fileName);
    info.appendChild(fileSize);

    // Create remove button
    const removeBtn = document.createElement('button');
    removeBtn.classList.add('attachment-remove');
    removeBtn.innerHTML = '&times;';
    removeBtn.type = 'button';
    removeBtn.title = 'Remove attachment';
    removeBtn.onclick = function(e) {
      e.preventDefault();
      removeAttachment(fileObj.id);
    };

    thumbnail.appendChild(preview);
    thumbnail.appendChild(info);
    thumbnail.appendChild(removeBtn);

    container.appendChild(thumbnail);
  });

}

function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

function onDescriptionInput() {
  var hasText = document.getElementById('comment').value.trim().length > 0;
  // Only show AI button if AI hasn't been used yet
  if (!aiUsed) {
    document.getElementById('aiEnhanceButton').style.display = hasText ? 'inline-block' : 'none';
  }
  formInput();
}

function enablePostAIFields() {
  // Category, priority, attachments, and submit are now always visible.
  // Show the verify message and activate the desktop sidebar layout.
  document.getElementById('aiVerifyMessage').style.display = '';
  document.getElementById('ticketContentWrapper').classList.add('sidebar-active');
  var commentLabel = document.querySelector('label[for="comment"]');
  if (commentLabel) commentLabel.textContent = 'Description';
  // Align the top of the sidebar with the top of the description textarea
  requestAnimationFrame(function() {
    var textarea = document.getElementById('comment');
    var formFields = document.getElementById('ticketFormFields');
    var sidebar = document.getElementById('aiRecommendedActions');
    if (textarea && formFields && sidebar) {
      var offset = textarea.getBoundingClientRect().top - formFields.getBoundingClientRect().top;
      if (offset > 0) {
        sidebar.style.marginTop = offset + 'px';
      }
    }
  });
}

function enhanceDescription() {
  var commentEl = document.getElementById('comment');
  var originalDescription = commentEl.value.trim();

  if (!originalDescription) {
    alert('Please enter a description first.');
    return;
  }

  var btn = document.getElementById('aiEnhanceButton');
  btn.disabled = true;
  btn.textContent = 'Kai AI is building your ticket...';

  var token = localStorage.getItem('kwest-api-token');

  // Collect category options so AI can suggest one
  var categories = categoryOptions.map(function(c) { return { name: c.name, value: c.value }; });

  // Collect image attachments as base64 data URLs (first 3 images only)
  var imagePromises = attachedFiles
    .filter(function(f) { return f.type.startsWith('image/'); })
    .slice(0, 3)
    .map(function(f) {
      return new Promise(function(resolve) {
        var reader = new FileReader();
        reader.onload = function(e) { resolve({ name: f.name, type: f.type, dataUrl: e.target.result }); };
        reader.onerror = function() { resolve({ name: f.name, type: f.type, dataUrl: null }); };
        reader.readAsDataURL(f.file);
      });
    });

  // Non-image attachments — pass name/type as context only
  var nonImageAttachments = attachedFiles
    .filter(function(f) { return !f.type.startsWith('image/'); })
    .map(function(f) { return { name: f.name, type: f.type, dataUrl: null }; });

  Promise.all(imagePromises).then(function(imageAttachments) {
    var allAttachments = imageAttachments.concat(nonImageAttachments);

    (async () => {
      try {
        var response = await fetch('/api/enhance-description', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            description: originalDescription,
            categories: categories,
            attachments: allAttachments
          })
        });

        var data = await response.json();

        if (!response.ok) {
          alert(data.message || 'Failed to enhance description');
          btn.disabled = false;
          btn.textContent = '\u2728 Let Kai build your ticket';
          return;
        }

        // Show original prompt first, then AI assessment below
        commentEl.value =
          'User\'s Original Prompt:\n' +
          originalDescription +
          '\n\n\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n' +
          'Kai AI Assessment:\n' +
          '\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n' +
          data.enhanced;

        // Autofill category if empty and AI suggested one
        if (data.suggestedCategory) {
          var categoryEl = document.getElementById('category');
          if (!categoryEl.value) {
            // Check the suggestion exists as a valid option
            var validOption = Array.from(categoryEl.options).find(function(o) {
              return o.value === data.suggestedCategory;
            });
            if (validOption) {
              categoryEl.value = data.suggestedCategory;
            }
          }
        }

        // Autofill priority if empty, never use urgent
        if (data.suggestedPriority) {
          var priorityEl = document.getElementById('priority');
          var safePriority = data.suggestedPriority.toLowerCase();
          if (safePriority === 'urgent') safePriority = 'high';
          if (!priorityEl.value) {
            priorityEl.value = safePriority;
          }
        }

        // Show recommended actions in green
        var actionsEl = document.getElementById('aiRecommendedActions');
        if (data.recommendedActions && data.recommendedActions.length > 0) {
          actionsEl.innerHTML = '';
          var header = document.createElement('p');
          header.classList.add('ai-actions-header');
          header.textContent = '\u2728 Kai AI Recommended Actions to Try:';
          actionsEl.appendChild(header);
          var ul = document.createElement('ul');
          ul.classList.add('ai-actions-list');
          data.recommendedActions.forEach(function(action) {
            var li = document.createElement('li');
            li.textContent = action;
            ul.appendChild(li);
          });
          actionsEl.appendChild(ul);
          actionsEl.style.display = 'block';
        } else {
          actionsEl.style.display = 'none';
        }

        // Hide the AI button permanently after one use
        btn.style.display = 'none';
        aiUsed = true;

        enablePostAIFields();
        formInput();
      } catch (e) {
        alert('Error enhancing description: ' + e.message);
        btn.disabled = false;
        btn.textContent = '\u2728 Let Kai build your ticket';
      }
    })();
  });
}

Object.assign(globalThis, {
  onLogin,
  loginFormInput,
  onTicket,
  formInput,
  triggerFileInput,
  ccClicked,
  handleFileSelection,
  onLogout,
  enhanceDescription,
  onDescriptionInput
})
